import { setLocalItem } from '../layer/store/localStore';
import { getFromQueryOrLocalStorage, isControl } from '../utils';
export function initializeControlAgeButtons(form) {
    const min = 0;
    const max = 8;
    const ageButtons = document.querySelectorAll('.age-button');
    ageButtons.forEach((ageButton) => {
        const decrementButton = ageButton.querySelector('.decrement-button');
        const incrementButton = ageButton.querySelector('.increment-button');
        const inputField = ageButton.querySelector('input[type="text"]');
        const updateButtons = (value) => {
            decrementButton.disabled = value <= min;
            incrementButton.disabled = value >= max;
        };
        decrementButton.addEventListener('click', () => {
            let currentValue = parseInt(inputField.value, 10);
            if (currentValue > min) {
                currentValue--;
                inputField.value = currentValue.toString();
                const dataValue = inputField.getAttribute('data-value');
                if (dataValue) {
                    form.set(dataValue, currentValue);
                    setLocalItem(dataValue, currentValue.toString());
                }
                updateButtons(currentValue);
            }
        });
        incrementButton.addEventListener('click', () => {
            let currentValue = parseInt(inputField.value, 10);
            if (currentValue < max) {
                currentValue++;
                inputField.value = currentValue.toString();
                const dataValue = inputField.getAttribute('data-value');
                if (dataValue) {
                    form.set(dataValue, currentValue);
                    setLocalItem(dataValue, currentValue.toString());
                }
                document
                    .querySelector(isControl()
                    ? '.qq-packages-type--control'
                    : '.qq-packages-type--variant')
                    .classList.remove('error');
                const element = document.querySelector(isControl()
                    ? '.qq-packages-type--control'
                    : '.qq-packages-type--variant');
                if (element) {
                    element.classList.remove('required');
                }
                updateButtons(currentValue);
            }
        });
        updateButtons(parseInt(inputField.value, 10));
    });
    ageButtons.forEach((ageButton) => {
        const inputField = ageButton.querySelector('input[type="text"]');
        const decrementButton = ageButton.querySelector('.decrement-button');
        const dataValue = inputField.getAttribute('data-value');
        if (dataValue) {
            const storedValue = getFromQueryOrLocalStorage(dataValue);
            if (storedValue &&
                !isNaN(parseInt(storedValue, 10)) &&
                parseInt(storedValue, 10) > 0) {
                inputField.value = storedValue;
                decrementButton.disabled = false;
                form.set(dataValue, parseInt(storedValue, 10));
            }
        }
    });
}
